import {
  STYLES_COLOR,
  STYLES_SIZE
} from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'

function Icon (props) {
  const {
    width,
    height,
    size,
    color,
    style,
    icon,
    className
  } = props

  const iconStyle = {
    width: width ? `${width}px` : size,
    height: height ? `${height}px` : size,
    color,
    display: 'block',
    margin: '0',
    fill: 'currentColor',
    transition: 'color 0.125s ease-out',
    ...style
  }

  if (!icon) {
    return <></>
  }

  const IconComp = icon
  return (
    <IconComp className={className} style={iconStyle} />
  )
}

Icon.SIZE = STYLES_SIZE
Icon.COLOR = STYLES_COLOR

Icon.defaultProps = {
  size: STYLES_SIZE.SMALL,
  className: '',
  style: {}
}

Icon.propTypes = {
  icon: PropTypes.func,
  color: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  style: PropTypes.object
}

export default Icon
